"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationPlayState = exports.AnimationFillMode = exports.AnimationDirection = exports.TimingFunctionKeyword = exports.StepDirection = void 0;
exports.StepDirection = new Set([
    'jump-start',
    'jump-end',
    'jump-none',
    'jump-both',
    'start',
    'end',
]);
exports.TimingFunctionKeyword = new Set([
    'ease',
    'ease-in',
    'ease-out',
    'ease-in-out',
    'linear',
    'step-start',
    'step-end',
]);
exports.AnimationDirection = new Set([
    'normal',
    'reverse',
    'alternate',
    'alternate-reverse',
]);
exports.AnimationFillMode = new Set([
    'none',
    'forwards',
    'backwards',
    'both',
]);
exports.AnimationPlayState = new Set([
    'paused',
    'running',
]);
